<!--Mobile Nav-->
<fgb-page-header [pageTitle]="'earn.page.title'" [showBalance]="false"></fgb-page-header>

<div class="container">
  <fgbcl-earn-points [lgWidth]="'4'"></fgbcl-earn-points>
</div>
